import React from 'react';
import { format } from "date-fns";
import InfoRedIcon from '@ui-kit/icons/alert-circle-warning500.svg';

import { Avatar, Icon, Text } from '@ui-kit';
import { geShortCut } from '@shared';


const UserItem = ({ user = {}, onClick = ()=>{} }) => {
  const {
    id,
    ava,
    compaign,
    firstName,
    lastName,
    createdAt,
    role,
    subRole,
    email,
    isSelected,
    isActivated,
    patronStatus = '',
    idTier = [],
    lastChargeStatus = '',
    referralCode = '',
    tariff = '',
    freePeriodFrom = 0,
    freePeriodTo = 0,
    patreonEmail = '',
  } = user;

  const chargeStatus = patronStatus && lastChargeStatus && idTier.length ? lastChargeStatus : 
                       patronStatus && !lastChargeStatus ? 'Trial' : '';
  const statusClass = ['status'];
  if (patronStatus === 'former_patron') {
    statusClass.push('former');
  };
  if (patronStatus === 'active_patron' && idTier.length) {
    statusClass.push('active');
  };
  if ((!patronStatus || !idTier.length) && patreonEmail ) {
    statusClass.push('follower');
  };
  
  const upperCase = (word) => {
    if (!word) {
      return;
    };
    const lowerCase = word.toLowerCase();
    return lowerCase.replace(lowerCase[0], lowerCase[0].toUpperCase());
  };

  const renderEmail = () => {
    if (!isActivated) {
      return (
        <div className="user-email">
          <h5>{compaign}</h5>
          <div className="d-flex noactivated">
            <Icon src={InfoRedIcon} />
            <h6>{email || ""}</h6>
          </div>
        </div>
      );
    };

    return (
      <div className="user-email">
        <h5>{compaign}</h5>
        <h6>{email || ''}</h6>
      </div>
    );
  };

  const formatTariff = () => {
    if (!freePeriodTo) return '';

    return (
      <Text as="h6" className="h7">{`
      ${format(new Date(freePeriodFrom), "dd.MM.yyyy HH:mm")} - 
      ${format(new Date(freePeriodTo), "dd.MM.yyyy HH:mm")}
    `}</Text>)
  }

  const formatDate = () => {
    return format(createdAt, "dd-MM-yyyy");
  }

  const formatTime = () => {
    return format(createdAt, "HH:mm:ss");
  }

  return (
    <div
      className={`admin__table-row ${isSelected && 'current'}`}
      onClick={() => onClick(id)}
    >
      <div className="d-flex ai-center user-name">
        <div className="pr user-avatar__wrapper">
          <Avatar 
            src={ava} 
            text ={geShortCut(firstName, lastName)}
          />
        </div>
        <div className="d-flex fd-column user-firstname">
          <h5>
            {firstName || ''}
          </h5>
          <h6>#{id}</h6>
        </div>
      </div>

      <div className="user-role">
        <h5>{upperCase(role)}</h5>
        <h6>{upperCase(subRole) || ''}</h6>
      </div>

      <div className="user-status">
        <h5 className={statusClass.join(' ')}>{patronStatus || 'follower'}</h5>
        <h6>{chargeStatus}</h6>
      </div>

      <div className="user-tariff">
        <h5>{tariff || 'Paid'}</h5>
        {formatTariff()}
      </div>

      {renderEmail()}

      <div className="user-referral">
        <h5>{referralCode || '-'}</h5>
      </div>

      <div className="user-create">
        <h5>{formatDate()}</h5>
        <h6>{formatTime()}</h6>
      </div>
    </div>
  );
};

export default UserItem;
